import { IDiscountProfile } from '@/modules/seller-management/discount-profile/types/discountProfileTypes'
import { ModelApi } from '@/services/api/modelApi'

export class DiscountProfileEndpoints extends ModelApi<IDiscountProfile> {
  constructor() {
    super('discount_profile')
  }
}
